import { UCL } from '../core/UserClientLibs'

const logout = async (isVoluntary) => {
    return await UCL.LogoutAsync({ embedShortCircuit: false, redirect: 'login', isVoluntary });
}

export default logout;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/logout.js